const ApiUrl = process.env.NEXT_PUBLIC_API_URL;
const InternalSsrApiUrl = process.env.INTERNAL_API_URL || ApiUrl;

const UrlParamsReplace = (
  url,
  params = {},
  queryParams = {},
  useInternalSsrApiUrl = false
) => {
  const baseUrl = useInternalSsrApiUrl ? InternalSsrApiUrl : ApiUrl;
  let urlWithPrefix = `${baseUrl}${url}`;
  if (params) {
    Object.keys(params).forEach(
      (key) => (urlWithPrefix = urlWithPrefix.replace(`:${key}`, params[key]))
    );
  }
  const queryParamsWithoutNull = {};
  if (queryParams) {
    Object.keys(queryParams).forEach((key) => {
      if (queryParams[key] !== undefined && queryParams[key] !== null) {
        queryParamsWithoutNull[key] = queryParams[key];
      }
    });
    const urlSearchParams = new URLSearchParams(queryParamsWithoutNull);
    urlWithPrefix += `?${urlSearchParams.toString()}`;
  }
  return urlWithPrefix;
};

// user
export const USER_LOGIN = UrlParamsReplace("/auth/mobile/sendOTP");
export const USER_SESSION = UrlParamsReplace("/auth/mobile/user");
export const USER_LOGOUT = UrlParamsReplace("/auth/user/logout");
export const MAP_RECRUITER = ({ companyId, userId }) =>
  UrlParamsReplace("/companies/:companyId/users/:userId/mapping", {
    companyId,
    userId,
  });

export const GET_MAPPED_RECRUITERS = (companyId, search, supervisorId) =>
  UrlParamsReplace("/users/:companyId/recruiter-mapping",
  {
    companyId,
  },
  {
    search,
    supervisorId
  }
);

export const GET_USERS_URL = (
  companyId,
  search,
  offset,
  limit,
  filters,
  sort
) =>
  UrlParamsReplace(
    "/companies/:companyId/users",
    {
      companyId,
    },
    {
      search,
      offset,
      limit,
      filters,
      sort,
    }
  );

export const GET_USER_FILTERS_URL = (
  companyId,
  filters
) =>
  UrlParamsReplace(
    "/users-filters/company/:companyId",
    {
      companyId,
    },
    {
      filters,
    }
  );
export const GET_USER_BY_ID_URL = (userId) =>
  UrlParamsReplace("/users/:userId", { userId });

export const GET_USER_ESSENTIAL_DETAILS_FOR_EDIT_URL = (userId) =>
  UrlParamsReplace("/users/:userId/essential", { userId });
export const GET_USER_BY_ID_AND_COMPANY_ID_URL = (
  userId,
  companyId,
  useInternalSsrApiUrl = false
) =>
  UrlParamsReplace(
    "/users/:userId/company/:companyId",
    { userId, companyId },
    {},
    useInternalSsrApiUrl
  );
export const GET_COMPANY_BY_USER_ID = (userId) =>
  UrlParamsReplace("/users/:userId/company", { userId });
export const GET_USER_BY_ID_NO_AUTH_URL = (userId) =>
  UrlParamsReplace("/users/:userId/noAuth", { userId });
export const REFRESH_USER_TOKEN = (userId) =>
  UrlParamsReplace("/refresh-token/:userId", { userId });
export const ADD_USER_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/users", { companyId });
export const UPDATE_USER_URL = (companyId, userId) =>
  UrlParamsReplace("/companies/:companyId/users/:userId", {
    companyId,
    userId,
  });
export const GET_ALL_USERS_URL = (search, filters, offset) =>
  UrlParamsReplace("/users", {}, { search, filters, offset });
export const ADD_USER_FROM_ADMIN = UrlParamsReplace("/users");
export const UPDATE_USER_FROM_ADMIN = (userId) =>
  UrlParamsReplace("/users/:userId", { userId });
export const GET_USER_BY_ROLE_ID_AND_COMPANY_ID = (roleId, companyId) =>
  UrlParamsReplace("/roles/:roleId/company/:companyId", { roleId, companyId });

// candidate
export const CANDIDATE_LOGIN = UrlParamsReplace(
  "/auth/mobile/sendCandidateOTP"
);
export const CANDIDATE_SESSION = UrlParamsReplace("/auth/mobile/candidate");
export const CANDIDATE_LOGOUT = UrlParamsReplace("/auth/candidate/logout");

export const CANDIDATE_CONFIDENCE_SCORE = (companyId) =>
  UrlParamsReplace("/companies/:companyId/candidates-confidence-score", {
    companyId,
  });
export const CANDIDATE_CONVERTED_STATUS = ({ companyId, filters }) =>
  UrlParamsReplace(
    "/companies/:companyId/candidate-converted-status",
    {
      companyId,
    },
    {
      filters,
    }
  );

export const CANDIDATE_ENGAGEMENT_SCORE = ({
  companyId,
  filters,
  offerAccepted,
}) =>
  UrlParamsReplace(
    "/companies/:companyId/candidates-engagement-score",
    {
      companyId,
    },
    {
      filters,
      offerAccepted,
    }
  );
export const GET_CANDIDATE_TOUCHPOINT_INSTANCES = (
  candidateId,
  search,
  touchPointStatus,
  offset,
  sort,
  limit,
  isEmployee = false
) =>
  UrlParamsReplace(
    "/touchpoint-instances/candidates/:candidateId",
    {
      candidateId,
    },
    {
      search,
      touchPointStatus,
      offset,
      sort,
      limit,
      isEmployee
    }
  );
export const ADD_CANDIATE_URL = (companyId, search, offset, sort, filters, fetchAll) =>
  UrlParamsReplace(
    "/companies/:companyId/candidates",
    {
      companyId,
    },
    {
      search,
      offset,
      sort,
      filters,
      fetchAll,
    }
  );
export const GET_HIRING_MANAGER_PORTAL_CANDIDATES_URL = (
  companyId,
  search,
  offset,
  sort,
  filters
) =>
  UrlParamsReplace(
    "/hiring-manager-portal/candidates",
    {},
    {
      companyId,
      search,
      offset,
      sort,
      ...(filters && { filters })
    }
  );
export const GET_CANDIDATE_REPORT = (companyId, selectedValue) => {
  return UrlParamsReplace(
    "/companies/:companyId/candidates/high-level-reports",
    {
      companyId,
    },
    {
      selectedValue,
    }
  );
};

export const GET_CANDIDATE_CCE_REPORT = (
  companyId,
  campaignTemplateId,
  selectedValues,
  isEmployee
) => {
  return UrlParamsReplace(
    "/reports/cce-status/:companyId/:campaignTemplateId",
    {
      companyId: companyId,
      campaignTemplateId: campaignTemplateId,
    },
    {
      selectedValues: selectedValues,
      isEmployee
    }
  );
};

export const UPDATE_CANDIATE_URL = (candidateId) =>
  UrlParamsReplace("/candidates/:candidateId", { candidateId });

export const GET_CANDIATE_URL = (candidateId, includeJoinedDate) =>
  UrlParamsReplace("/candidates/:candidateId", { candidateId }, { includeJoinedDate });

export const GET_CANDIDATE_SUMMARY_URL = (candidateId) =>
  UrlParamsReplace("/candidates/:candidateId/summary", { candidateId });

export const GET_CANDIDATE_INTERVENTIONS_URL = (candidateId, limit) =>
  UrlParamsReplace("/candidates/:candidateId/interventions", { candidateId }, { limit });

export const GET_INTERVENTION_BY_ID_URL = (candidateId, interventionId) =>
  UrlParamsReplace("/candidates/:candidateId/interventions/:interventionId", { candidateId, interventionId });

export const GET_CANDIDATE_CALL_HISTORY_LIST_URL = (candidateId) =>
  UrlParamsReplace("/candidates/:candidateId/call-history", { candidateId });

export const GET_INTERVENTION_CALL_DETAILS_URL = (candidateId, interventionId) =>
  UrlParamsReplace("/candidates/:candidateId/interventions/:interventionId/call-details", { candidateId, interventionId });

export const UPDATE_CANDIATE_STATUS_URL = (candidateId) =>
  UrlParamsReplace("/candidates/:candidateId/status", { candidateId });

export const VALIDATE_CANDIDATES_FROM_CSV_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/bulk-candidates-validations", {
    companyId,
  });

export const AUTH_EMPLOYEE_MAGIC_LINK = () => {
   return UrlParamsReplace(
      "/authorize-magic-link"
    );
};


export const ADD_BULK_CANDIDATES_FROM_CSV_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/bulk-candidates", { companyId });
export const DEACTIVATE_CANDIDATES_URL = UrlParamsReplace(
  "/candidates/deactivate"
);

export const ADD_RECRUITER_SCORE = (companyId) =>
  UrlParamsReplace("/companies/:companyId/recruiter-score", { companyId });

export const DELETE_RECRUITER_SCORE = (companyId, scoreId) =>
  UrlParamsReplace("/companies/:companyId/recruiter-score/:scoreId", {
    companyId,
    scoreId,
  });

export const EDIT_RECRUITER_SCORE = (companyId, scoreId) =>
  UrlParamsReplace("/companies/:companyId/recruiter-score/:scoreId", {
    companyId,
    scoreId,
  });

export const UPDATE_CANIDATE_WHATSAPP_CONSENT = (candidateId) =>
  UrlParamsReplace("/candidates/:candidateId/whatsapp-consent", {
    candidateId,
  });

// designations
export const GET_DESIGNATIONS_URL = (companyId, search, offset, limit, sort) =>
  UrlParamsReplace(
    "/companies/:companyId/designations",
    {
      companyId,
    },
    {
      search,
      offset,
      limit,
      sort,
    }
  );

export const UPDATE_DESIGNATION_URL = (designationId) =>
  UrlParamsReplace("/designations/:designationId", { designationId });

//  position
export const ADD_POSITION_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/positions", { companyId });
export const UPDATE_POSITION_URL = (positionId) =>
  UrlParamsReplace("/positions/:positionId", { positionId });
export const GET_POSITIONS_URL = (
  companyId,
  search,
  offset,
  limit,
  sort,
  filters
) =>
  UrlParamsReplace(
    "/companies/:companyId/positions",
    {
      companyId,
    },
    {
      search,
      offset,
      limit,
      sort,
      filters,
    }
  );
export const GET_POSITION_BY_ID_URL = (positionId) =>
  UrlParamsReplace("/positions/:positionId", { positionId });

export const UPDATE_POSITION_STATUS_URL = (positionId) =>
  UrlParamsReplace("/positions/:positionId/status", { positionId });

export const VALIDATE_POSITIONS_FROM_CSV_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/bulk-positions-validations", {
    companyId,
  });
  
export const UPDATE_POSITION_JOURNEY_URL = (companyId) => 
  UrlParamsReplace("/companies/:companyId/positions/update-journey", { companyId });

export const ADD_BULK_POSITIONS_FROM_CSV_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/bulk-positions", { companyId });
export const DEACTIVATE_POSITIONS_URL = UrlParamsReplace(
  "/positions/deactivate"
);

// campaign template
export const CREATE_CAMPAIGN_TEMPLATE_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/campaign-templates", { companyId });
export const GET_CAMPAIGN_TEMPLATES_URL = (
  companyId,
  offset,
  search,
  sort,
  status,
  filters
) =>
  UrlParamsReplace(
    "/companies/:companyId/campaign-templates",
    {
      companyId,
    },
    {
      offset,
      search,
      status,
      sort,
      filters,
    }
  );
export const GET_MY_JOURNEYS_URL = (
  companyId,
  offset,
  search,
  sort,
  status,
  filters,
  limit,
) =>
  UrlParamsReplace(
    "/companies/:companyId/my-journeys",
    {
      companyId,
    },
    {
      offset,
      search,
      status,
      sort,
      filters,
      limit,
    }
  );
export const UPDATE_CAMPAIGN_TEMPLATE_URL = (templateId) =>
  UrlParamsReplace("/campaign-templates/:templateId", {
    templateId,
  });
export const UPDATE_CAMPAIGN_TEMPLATE_STATUS_URL = (templateId) =>
  UrlParamsReplace("/campaign-templates/:templateId/status", {
    templateId,
  });
export const GET_CAMPAIGN_TEMPLATE_REPORTS = (companyId, search, filters) =>
  UrlParamsReplace(
    "/companies/:companyId/campaignReports",
    {
      companyId,
    },
    {
      search,
      filters,
    }
  );

export const GET_TOP_CAMPAIGN_TEMPLATES = (companyId, filters, limit) =>
  UrlParamsReplace(
    "/companies/:companyId/topCampaignTemplates",
    {
      companyId,
    },
    {
      filters,
      limit,
    }
  );

//mark as default campaign tempalte

export const MARK_AS_DEFAULT_CAMPAIGN_TEMPLATE_URL = (companyId) => {
  return UrlParamsReplace("/companies/:companyId/campaign-templates/default", {
    companyId,
  });
};
// touch point instances
export const GET_ALL_TASKS = (
  companyId,
  search,
  touchPointStatus,
  offset,
  filters,
  sort
) =>
  UrlParamsReplace(
    "/company/:companyId/touchpoint-instances",
    { companyId },
    {
      search,
      touchPointStatus,
      offset,
      filters,
      sort,
    }
  );
export const GET_MY_TASKS = (
  ownerId,
  companyId,
  search,
  touchPointStatus,
  offset,
  filters,
  sort
) =>
  UrlParamsReplace(
    "/company/:companyId/touchpoint-instances/owners/:ownerId",
    { companyId, ownerId },
    {
      search,
      touchPointStatus,
      offset,
      filters,
      sort,
    }
  );
export const GET_TOUCHPOINT_INSTANCE = (id) =>
  UrlParamsReplace("/touchpoint-instances/:id", { id });
export const RUN_TOUCHPOINT_INSTANCE = (id, isPostJoining) =>
  UrlParamsReplace("/touchpoint-instances/:id/run", { id },{ isPostJoining });
export const MARK_AS_COMPLETE_TOUCHPOINT_INSTANCE = (id) =>
  UrlParamsReplace("/touchpoint-instances/:id/completed", { id });
export const RATE_TOUCHPOINT_INSTANCE = (id) =>
  UrlParamsReplace("/touchpoint-instances/:id/rate", { id });
export const DEACTIVATE_TOUCHPOINT_INSTANCES = UrlParamsReplace(
  "/touchpoint-instances/deactivate"
);
export const GET_BULK_TOUCHPOINT_INSTANCES = (companyId) =>
  UrlParamsReplace("/companies/:companyId/touchpoint-instances/bulk", {
    companyId,
  });
export const BULK_UPDATE_TOUCHPOINT_INSTANCES = UrlParamsReplace(
  "/touchpoint-instances/bulk/edit"
);
export const UPDATE_TOUCHPOINT_STATUS = (id) =>
  UrlParamsReplace("/touchpoint-instances/:id/touchPointStatus", { id });
export const GET_TOUCHPOINT_INSTANCE_EFFECTIVENESS = (companyId, filters) =>
  UrlParamsReplace(
    "/companies/:companyId/tasks-effectiveness",
    { companyId },
    { filters }
  );

export const ENGAGEMENT_TIME_URL = UrlParamsReplace("/engagement-time");
export const ADD_ENGAGEMENT_ACTIVITY = UrlParamsReplace("/engagement-metric");

export const GET_PUBLISHED_NEWS_FEED = (companyId) =>
  UrlParamsReplace("/companies/:companyId/news-feeds/published", { companyId });

export const GET_LINKEDIN_POSTS = (companyId) =>
  UrlParamsReplace("/companies/:companyId/linkedinPost", { companyId });

export const GET_NEWS_FEEDS = (companyId, offset, search, sort) =>
  UrlParamsReplace(
    "/companies/:companyId/news-feeds",
    {
      companyId,
    },
    {
      offset,
      search,
      sort,
    }
  );
export const GET_PRE_SIGNED_URL = UrlParamsReplace("/aws/get-pre-signed-url");

export const GET_SIGNED_URL = (fileKey) =>
  UrlParamsReplace("/aws/get-s3-signed-url", {}, { fileKey });
export const GET_UPLOAD_PRE_SIGNED_URL = UrlParamsReplace(
  "/aws/get-upload-pre-signed-url"
);
export const CREATE_NEWS_FEED = (companyId) =>
  UrlParamsReplace("/companies/:companyId/news-feeds", { companyId });

export const GET_NEWS_FEED = (newsFeedId) =>
  UrlParamsReplace("/news-feeds/:newsFeedId", { newsFeedId });

export const GET_ROLES = (allRoles) =>
  UrlParamsReplace("/roles", {}, { allRoles });

//employees
  export const GET_EMPLOYEES_URL = (companyId, search, offset, filters, includeAdditional) =>
    UrlParamsReplace("/company/:companyId/employees", {
      companyId,
    },{ search, offset, filters, includeAdditional });
  export const GET_EMPLOYEES_REPORT_URL = (companyId, selectedValue) =>
    UrlParamsReplace("/companies/:companyId/employees/high-level-reports", {
      companyId,
    },{ selectedValue });
 
  export const DEACTIVATE_EMPLOYEES_URL = () =>
    UrlParamsReplace("/employees/deactivate", {}, { });

  export const GET_EMPLOYEE_URL = (employeeId) =>
    UrlParamsReplace("/employees/:employeeId", {
      employeeId,
    });
  export const UPDATE_WORK_EMAIL_URL = (employeeId, workEmail) => 
    UrlParamsReplace("/employees/:employeeId/work-email", { employeeId });
  export const VALIDATE_EMPLOYEES_FROM_CSV_URL = (companyId) =>
    UrlParamsReplace("/companies/:companyId/bulk-employees-validations", {
      companyId,
    });
  export const ADD_EMPLOYEES_FROM_CSV_URL = (companyId) =>
    UrlParamsReplace("/company/:companyId/employees/csv", {
      companyId,
    });
// company
export const GET_COMPANIES_URL = (
  search,
  offset,
  limit,
  filters,
  getSignedUrls
) =>
  UrlParamsReplace(
    "/companies",
    {},
    { search, offset, limit, filters, getSignedUrls }
  );

export const ADD_COMPANY_URL = UrlParamsReplace("/company");

export const GET_BASIC_COMPANY_DETAILS_URL = (search) =>
  UrlParamsReplace("/companies/basic", {}, { search });

export const GET_COMPANY_URL = (companyId) =>
  UrlParamsReplace("/company/:companyId", {
    companyId,
  });
export const GET_COMPANY_NO_AUTH = (slug) =>
  UrlParamsReplace("/company/:slug/noAuth", {
    slug,
  });
export const UPDATE_COMPANY_CUSTOM_ATTRIBUTE_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/custom-attributes", {
    companyId,
  });

export const UPDATE_COMPANY_THEMES = (companyId) =>
  UrlParamsReplace("/companies/:companyId/themes", {
    companyId,
  });

export const UPDATE_COMPANY_SETTINGS = (companyId) =>
    UrlParamsReplace("/companies/:companyId/settings", {
      companyId,
  });

export const UPDATE_COMPANY_FONTS = (companyId) =>
  UrlParamsReplace("/companies/:companyId/fonts", {
    companyId,
  });

export const GET_TASK_ERRORS_URL = (companyId, search, offset, filters) =>
  UrlParamsReplace(
    "/companies/:companyId/task-errors",
    {
      companyId,
    },
    {
      search,
      offset,
      filters,
    }
  );
export const GET_MY_TASK_ERRORS_URL = (ownerId, search, offset, filters) =>
  UrlParamsReplace(
    "/touchpoint-instances/owners/:ownerId/task-errors",
    {
      ownerId,
    },
    {
      search,
      offset,
      filters,
    }
  );
export const UPDATE_TASK_ERRORS_URL = (taskErrorId) =>
  UrlParamsReplace(
    "/touchpoint-instances/task-errors/:taskErrorId",
    {
      taskErrorId,
    },
    {}
  );
export const RETRY_TASK_ERRORS_URL = (taskErrorId) =>
  UrlParamsReplace(
    "/touchpoint-instances/task-errors/:taskErrorId/retry",
    {
      taskErrorId,
    },
    {}
  );
export const GET_CANDIDATES_TASK_ERRORS = (candidateId, search, offset, sort, isEmployee) =>
  UrlParamsReplace(
    "/task-errors/candidates/:candidateId",
    {
      candidateId,
    },
    {
      search,
      offset,
      sort,
      isEmployee
    }
  );

//senders

export const ADD_SENDERS = (companyId) =>
  UrlParamsReplace("/companies/:companyId/senders", {
    companyId,
  });

export const GET_SENDERS = (companyId, search) =>
  UrlParamsReplace(
    "/companies/:companyId/senders",
    {
      companyId,
    },
    { search }
  );

export const CHECK_SENDER_USED = (companyId, senderId) =>
  UrlParamsReplace("/companies/:companyId/senders/:senderId", {
    companyId,
    senderId,
  });

export const DELETE_SENDER = (companyId, senderId) =>
  UrlParamsReplace("/companies/:companyId/senders/:senderId", {
    companyId,
    senderId,
  });

export const UPDATE_SENDER = (companyId, senderId) =>
  UrlParamsReplace("/companies/:companyId/senders/:senderId", {
    companyId,
    senderId,
  });
//html templates
export const ADD_HTML_TEMPLATE_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/html-templates", { companyId });
export const GET_HTML_TEMPLATE_URL = (htmlTemplateId) =>
  UrlParamsReplace("/html-templates/:htmlTemplateId", { htmlTemplateId });
export const GET_HTML_TEMPLATES_URL = (
  companyId,
  search,
  offset,
  limit,
  sort,
  status
) =>
  UrlParamsReplace(
    "/companies/:companyId/html-templates",
    {
      companyId,
    },
    {
      search,
      offset,
      limit,
      sort,
      status,
    }
  );
export const DELETE_HTML_TEMPLATE_URL = (companyId, htmlTemplateId) =>
  UrlParamsReplace("/companies/:companyId/html-templates/:htmlTemplateId", {
    companyId,
    htmlTemplateId,
  });
export const ADD_CUSTOM_CSS_TO_HTML_TEMPLATE_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/html-templates/custom-css", {
    companyId,
  });

export const UPDATE_TOUCHPOINT_INSTANCE_SURVERY_ANSWERE = (id) =>
  UrlParamsReplace("/touchpoint-instances/:id/survery-answers", { id });

export const UPDATE_TOUCHPOINT_INSTANCE_QUIZ_ANSWERED = (id) =>{
  return UrlParamsReplace("/touchpoint-instances/:id/quiz-answers", { id });
}

export const ADD_SURVEY_TEMPLATE_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/survey-templates", { companyId });

export const GET_SURVEY_TEMPLATES_URL = (
  companyId,
  search,
  status,
  offset,
  limit,
  sort
) =>
  UrlParamsReplace(
    "/companies/:companyId/survey-templates",
    {
      companyId,
    },
    {
      search,
      offset,
      limit,
      sort,
      status,
    }
  );

export const GET_SURVEY_TEMPLATE_URL = (surveyTemplateId) =>
  UrlParamsReplace("/survey-templates/:surveyTemplateId", { surveyTemplateId });

export const GET_DESCRIPTION_URL = (surveyTemplateId) =>
  UrlParamsReplace("/survey-templates/:surveyTemplateId/description", {
    surveyTemplateId,
  });
  
export const GET_QUIZ_TEMPLATE_URL = (quizTemplateId) =>
  UrlParamsReplace("/quiz-templates/:quizTemplateId/template", {
    quizTemplateId,
  });
  
export const ADD_CANDIDATE_NEWSFEED_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/candidate-news-feeds", { companyId });
export const GET_CANDIDATE_NEWSFEED_URL = (companyId, candidateId) =>
  UrlParamsReplace("/companies/:companyId/candidate-news-feeds/:candidateId", {
    companyId,
    candidateId,
  });

//audit logs

export const GET_AUDIT_LOGS_BY_ENTITY_ID = (companyId, entityId, isCandidate) =>
  UrlParamsReplace(
    "/companies/:companyId/audit-logs/:entityId",
    {
      companyId,
      entityId,
    },
    {
      isCandidate: isCandidate,
    }
  );

export const GET_EMPLOYEE_AUDIT_LOGS_BY_ENTITY_ID = (companyId, entityId) =>
  UrlParamsReplace(
    "/companies/:companyId/employees/:entityId/audit-logs",
    {
      companyId,
      entityId,
    }
  );

// time-slots

export const GET_TIME_SLOTS_URL = (companyId, touchPointInstanceId) =>
  UrlParamsReplace("/companies/:companyId/timeSlots/:touchPointInstanceId", {
    companyId,
    touchPointInstanceId,
  });

export const GET_BOOKED_TIME_SLOTS_URL = (companyId, touchPointInstanceId) =>
  UrlParamsReplace(
    "/companies/:companyId/booked/timeSlots/:touchPointInstanceId",
    {
      companyId,
      touchPointInstanceId,
    }
  );

export const GET_TIME_SLOT_BY_ID_URL = (timeSlotId) =>
  UrlParamsReplace("/timeSlots/:timeSlotId", { timeSlotId });

export const GET_CONFLICTING_TIME_SLOTS_URL = (userId, hash) =>
  UrlParamsReplace("/time-slots/:userId/conflicts", { userId }, { hash });

export const GET_HIRING_MANAGER_CONFLICTING_TIME_SLOTS_URL = (userId) =>
  UrlParamsReplace("/hiring-manager-portal/time-slots/:userId/conflicts", { userId });

export const CREATE_TIME_SLOTS_URL = ({
  companyId,
  userId,
  touchPointInstanceId,
  timeSlots,
  timeZone,
  hash
}) =>
  UrlParamsReplace(
    "/companies/:companyId/timeSlots",
    {
      companyId,
    },
    {
      userId,
      touchPointInstanceId,
      timeSlots,
      timeZone,
      hash
    }
  );

export const CREATE_HIRING_MANAGER_TIME_SLOTS_URL = ({
  companyId,
}) =>
  UrlParamsReplace(
    "/hiring-manager-portal/companies/:companyId/timeSlots",
    {
      companyId,
    }
  );

export const SEND_NEED_HELP_EMAIL_URL = ({
  companyId,
  userId,
  touchPointInstanceId,
}) =>
  UrlParamsReplace(
    "/companies/:companyId/timeSlots/needHelp",
    {
      companyId,
    },
    {
      userId,
      touchPointInstanceId,
    }
  );

export const SEND_EXPIRED_SLOTS_SUPPORT_EMAIL_URL = () =>
  UrlParamsReplace("/timeSlots/expiredSlotsSupport");

export const UPDATE_TIME_SLOT_STATUS_URL = (timeSlotId, status) =>
  UrlParamsReplace(
    "/timeSlots/:timeSlotId",
    {
      timeSlotId,
    },
    { status }
  );

//meeting-link
export const GET_MEETING_LINKS_URL = (companyId, search, offset, limit) =>
  UrlParamsReplace(
    "/companies/:companyId/meetingLinks",
    {
      companyId,
    },
    {
      search,
      offset,
      limit,
    }
  );

export const UPDATE_MEETING_LINK_URL = (companyId, meetingLinkId) =>
  UrlParamsReplace(
    "/companies/:companyId/meetingLinks/:meetingLinkId",
    {
      companyId,
      meetingLinkId,
    },
    {}
  );

export const DELETE_MEETING_LINK_URL = (companyId, meetingLinkId) =>
  UrlParamsReplace(
    "/companies/:companyId/meetingLinks/:meetingLinkId",
    {
      companyId,
      meetingLinkId,
    },
    {}
  );

export const SMTP_EMAIL_TRACKING_URL = (touchPointInstanceId, url) =>
  UrlParamsReplace(
    "/smtp-email-tracking",
    {},
    {
      url,
      touchPointInstanceId,
    }
  );

//meeting-location
export const GET_MEETING_LOCATION_URL = (companyId, search, offset, limit) =>
  UrlParamsReplace(
    "/companies/:companyId/meeting-location",
    {
      companyId,
    },
    {
      search,
      offset,
      limit,
    }
  );

export const SEND_EMAIL_URL = UrlParamsReplace("/send-email");

export const GET_EMAIL_VARIANTS_URL = UrlParamsReplace("/emailVariants");

export const GENERATE_SURVEY_REPORT = (campaignTemplateId, reportType) =>
  UrlParamsReplace(
    "/campaign-templates/:campaignTemplateId/survey-result",
    { campaignTemplateId },
    reportType ? { reportType } : {}
  );

// export const GET_EMAIL_VARIANTS_URL = (
//   subject,
//   mainPoints,
//   keywords,
//   tone,
//   words,
//   variants,
//   trackingTemplateId
// ) => {
//   return UrlParamsReplace(
//     "/emailVariants",
//     {},
//     {
//       subject,
//       mainPoints,
//       keywords,
//       tone,
//       words,
//       variants,
//       trackingTemplateId,
//     }
//   );
// };

//linkedin posts
export const GET_LINKEDIN_POST_URL = (companyId, search, offset, limit) =>
  UrlParamsReplace(
    "/companies/:companyId/linkedinPost",
    {
      companyId,
    },
    {
      search,
      offset,
      limit,
    }
  );

export const UPDATE_LINKEDIN_POST_URL = (companyId, linkedinPostId) =>
  UrlParamsReplace(
    "/companies/:companyId/linkedinPost/:linkedinPostId",
    {
      companyId,
      linkedinPostId,
    },
    {}
  );

export const DOMO_REPORT_URL = (companyId, search, offset, limit) =>
  UrlParamsReplace(
    "/companies/:companyId/domoReports",
    {
      companyId,
    },
    {
      search,
      offset,
      limit,
    }
  );

export const DOMO_REPORT_BY_ID_URL = (companyId, id) =>
  UrlParamsReplace("/companies/:companyId/domoReports/:id", {
    companyId,
    id,
  });

export const DELETE_LINKEDIN_POST_URL = (companyId, postID) =>
  UrlParamsReplace(
    "/companies/:companyId/linkedinPost/:postID",
    {
      companyId,
      postID,
    },
    {}
  );

export const GET_INTERVENTION_CHECKPOINTS = ({ companyId }) =>
  UrlParamsReplace("/intervention_checkpoints/:companyId", {companyId});

export const VALIDATE_USERS_FROM_CSV_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/bulk-users-validations", {
    companyId,
  });

export const ADD_BULK_USERS_FROM_CSV_URL = (companyId) =>
  UrlParamsReplace("/companies/:companyId/bulk-users-create", { companyId });

export const MODIFY_DOMO_REPORT_URL = (companyId, id) =>
  UrlParamsReplace(
    "/companies/:companyId/domoReports/:id",
    {
      companyId,
      id,
    },
    {}
  );

export const DOMO_EMBED_TOKEN_URL = (companyName, reportId) =>
  UrlParamsReplace(
    "/companies/:companyName/domoReports/:reportId/embedToken",
    {
      companyName,
      reportId,
    }
  );

export const GET_POSITIONS_BULK_DOWNLOAD_URL = (
  companyId,
  search,
  offset,
  limit,
  sort,
  filters
) =>
  UrlParamsReplace(
    "/companies/:companyId/positions-bulk-download",
    {
      companyId,
    },
    {
      search,
      offset,
      limit,
      sort,
      filters,
    }
  );

export const ADD_SUPER_ADMIN_TOUCHPOINT_URL = () =>
  UrlParamsReplace("/journeys/touch-points");

export const GET_TOUCHPOINTS = (
  search = null,
  filters = null,
  offset = null,
  listing = false,
  limit = 10
) =>
  UrlParamsReplace(
    "/journeys/touch-points",
    {},
    { search, filters, offset, listing, limit }
  );

export const GET_TOUCHPOINT_BY_ID = (touchpointID) =>
  UrlParamsReplace("/touchpoint/:touchpointID", { touchpointID });

export const ADD_JOURNEY = (companyId) =>
  UrlParamsReplace("/companies/:companyId/journey", {
    companyId,
  });

export const GET_JOURNEY_TEMPLATES_URL = (companyId) =>
  UrlParamsReplace("/journey-templates?companyId=:companyId", {
    companyId,
  });

export const GET_JOURNEY = (offset, search, sort, status) =>
  UrlParamsReplace(
    "/journey-templates",
    {},
    {
      offset,
      search,
      status,
      sort,
    }
  );

export const GET_ADMIN_JOURNEY = () =>
  UrlParamsReplace("/journey-templates-for-use");

export const GET_JOURNEY_CATEGORY = (
  search = null,
  offset = null,
  limit = null
) => UrlParamsReplace("/journey-categories", {}, { search, offset, limit });

export const GET_JOURNEY_CATEGORY_BY_ID = (id) =>
  UrlParamsReplace("/journey-categories/:id", { id });

export const ADD_JOURNEY_CATEGORY = () =>
  UrlParamsReplace("/journey-categories");

export const UPDATE_JOURNEY_CATEGORY = (id) =>
  UrlParamsReplace("/journey-categories/:id", { id });

export const UPDATE_SUPER_ADMIN_TOUCHPOINT_URL = (id) => UrlParamsReplace("/touchpoint/:id", { id });

export const EDIT_JOURNEY = ({ companyId, templateId }) =>
  UrlParamsReplace("/companies/:companyId/journey/:templateId", {
    companyId,
    templateId,
  });

export const UPDATE_SUPER_ADMIN_TOUCHPOINT_STATUS_URL = (id) => UrlParamsReplace("/touchpoint/:id/status", { id });

export const GET_PRECALL_QUESTIONS = (stage) =>
  UrlParamsReplace(
    `/candidate_call_questions`,
    {},
    {
      stage,
    }
  );

  export const CREATE_CANDIDATE_CALL_HISTORY_URL = (candidateId) =>
    UrlParamsReplace("/callhistory/:candidateId", { candidateId });

  export const UPDATE_CANDIDATE_CALL_HISTORY_URL = (callSid) =>
    UrlParamsReplace("/callhistory/:callSid", { callSid });

  export const GET_CANDIDATE_CALL_HISTORY_URL = ({candidateId}) =>
  {
   return UrlParamsReplace(
      `/callhistory`,
      {},
      {
        candidateId,
      }
    )
  }

  export const UPDATE_TOUCHPOINT_INSTANCE_SEND_REMINDER = (id) => 
    UrlParamsReplace("/touchpoint-instances/:id/touchpoint-send-reminder", { id });

  export const GET_COMPANY_AND_ROLES_BY_USERID_COMPANYID_URL = (userId,companyId) =>
    UrlParamsReplace("/user/:userId/company/:companyId", { userId ,companyId});

export const GET_USERS_FOR_SPOC_URL = () =>
    UrlParamsReplace('/users/list/spoc');

// Filter APIs
export const GET_USERS_FOR_FILTER_URL = (companyId, role) =>
  UrlParamsReplace("/filters/users", {}, { companyId, role });

export const GET_JOURNEYS_FOR_FILTER_URL = (companyId) =>
  UrlParamsReplace("/filters/journeys", {}, { companyId });

export const GET_COMPANIES_FOR_FILTER_URL = () =>
  UrlParamsReplace("/filters/companies");

export const GET_COMPANY_ADMINS_FOR_FILTER_URL = () =>
  UrlParamsReplace("/filters/company-admins");

export const GET_ROLES_FOR_FILTER_URL = () =>
  UrlParamsReplace("/filters/roles");

export const GET_COMPANY_CUSTOM_ATTRIBUTES_FOR_FILTER_URL = (companyId) =>
  UrlParamsReplace("/filters/company-custom-attributes", {}, { companyId });

export const GET_SCHEDULER_INFO_URL = (touchPointInstanceId, hash) =>
  UrlParamsReplace(
    "/scheduler-info/:touchPointInstanceId",
    { touchPointInstanceId },
    { hash }
  );

  
export const GET_FEEDBACK_INFO_URL = (touchPointInstanceId, hash, timeSlotId) =>
  UrlParamsReplace(
    "/feedback-info/:touchPointInstanceId",
    { touchPointInstanceId },
    { hash, timeSlotId }
  );

export const SUBMIT_MEETING_PERSON_FEEDBACK_URL = (touchPointInstanceId) =>
  UrlParamsReplace(
    "/feedback/:touchPointInstanceId",
    { touchPointInstanceId }
  );

export const GET_HIRING_MANAGER_FEEDBACK_INFO_URL = (touchPointInstanceId) =>
  UrlParamsReplace(
    "/hiring-manager-portal/feedback-info/:touchPointInstanceId",
    { touchPointInstanceId }
  );

export const SUBMIT_HIRING_MANAGER_MEETING_PERSON_FEEDBACK_URL = (touchPointInstanceId) =>
  UrlParamsReplace(
    "/hiring-manager-portal/feedback/:touchPointInstanceId",
    { touchPointInstanceId }
  );

export const RETRIGGER_MEETING_SLOTS_LINK_URL = (touchPointInstanceId) =>
  UrlParamsReplace(
    "/touchpoint-instances/:touchPointInstanceId/retrigger-meeting-slots-link",
    { touchPointInstanceId }
  );

export const UPDATE_OR_DELETE_MEETING_LOCATION_URL = (companyId, id) =>
  UrlParamsReplace(
    "/companies/:companyId/meeting-location/:id",
    {
      companyId,
      id,
    },
    {}
  );

export const GET_CANDIDATE_TOUCHPOINT_INSTANCES_FOR_CANDIDATE_HUB = (
  candidateId,
  search,
  touchPointStatus,
  offset,
  sort,
  limit,
  isEmployee
) => {
  return UrlParamsReplace(
    "/touchpoint-instances-for-candidate-hub/candidates/:candidateId",
    {
      candidateId,
    },
    {
      search,
      touchPointStatus,
      offset,
      sort,
      limit,
      isEmployee
    }
  );
};

export const SEND_TEAMS_ALERT_URL = UrlParamsReplace("/alerts/send-teams-alert");
export const REFRESH_EXOTEL_TOKEN_URL = UrlParamsReplace("/refresh-exotel-token");

export const GET_HIRING_MANAGER_PORTAL_FILTERS_URL = (companyId) =>
  UrlParamsReplace("/hiring-manager-portal/:companyId/filters", { companyId });

// Hiring Manager Portal Magic Link Validation (hash sent via x-hiring-manager-portal-hash header)
export const VALIDATE_HIRING_MANAGER_MAGIC_LINK = () =>
  UrlParamsReplace("/hiring-manager-portal-validate");

export const RESEND_HIRING_MANAGER_MAGIC_LINK_URL = () =>
  UrlParamsReplace("/hiring-manager-portal/resend-magic-link");

export const GET_HIRING_MANAGER_PORTAL_S3_SIGNED_URL = (filePath) =>
  UrlParamsReplace("/hiring-manager-portal/s3-signed-url", {}, { filePath });

export const CLIENT_LOG_URL = () => UrlParamsReplace("/client-log");
